import React, { useState, ChangeEvent } from 'react';

interface EditTextGradeDatamodel {
  defaultValue?: number;
  width?: string;
  height?: string;
  onChange?: (value: number) => void;
}

const EditTextGrade: React.FC<EditTextGradeDatamodel> = ({
  width,
  height,
  defaultValue,
  onChange,
}) => {
  const [value, setValue] = useState<number | string>(
    defaultValue ? defaultValue : '',
  );

  const useStyle = {
    ...(width && { width: `${width}` }), // Conditionally add maxWidth
    ...(height && { height: `${height}` }), // Conditionally add maxWidth
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;

    // Handle empty input separately
    if (newValue === '') {
      setValue('');
    } else {
      const numericValue = Number(newValue);

      // Validate and adjust the value to be within the range 0-100
      if (numericValue < 0) {
        setValue(0);
      } else if (numericValue > 100) {
        setValue(100);
      } else {
        setValue(numericValue);
      }
    }
    onChange && onChange(Number(newValue));
  };

  return (
    <input
      style={{
        padding: '7px',
        ...useStyle,
        border: '#E6E6E6 2px solid',
        borderRadius: '5px',
      }}
      type="number"
      value={value}
      onChange={handleChange}
      min={0}
      max={100}
    />
  );
};

export default EditTextGrade;
